const updates = [
  { title: '《星辰变》第286话更新：秦羽突破天阶，大战将启', date: '2026-07-29', tag: '最新更新' },
  { title: '《偷偷藏不住》番外篇上线：婚后甜蜜日常', date: '2026-07-28', tag: '番外上线' },
  { title: '新增韩漫专区：《某天成为公主》全本完整版', date: '2026-07-27', tag: '全本上架' },
  { title: '《诡秘之主》漫画化第二季官宣，读者期待值拉满', date: '2026-07-26', tag: '重磅消息' },
  { title: '《一人之下》第512话：老天师出手，场面燃爆', date: '2026-07-25', tag: '热门连载' },
  { title: '樱花漫画网APP 3.0版本发布，阅读体验全面升级', date: '2026-07-24', tag: '版本更新' },
  { title: '《全球诡异时代》第198话：新诡异种登场', date: '2026-07-23', tag: '最新更新' },
  { title: '暑期漫画推荐专题上线：百部全本漫画一次看够', date: '2026-07-22', tag: '专题推荐' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-4">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          热门漫画更新快讯与平台动态，不错过每一话精彩
        </p>
        <div className="relative">
          <div className="absolute left-4 md:left-5 top-0 bottom-0 w-px bg-background-300/60"></div>
          <div className="space-y-6">
            {updates.map((item, idx) => (
              <div key={idx} className="relative pl-10 md:pl-12">
                <div className={`absolute left-2.5 md:left-3.5 top-1.5 w-3 h-3 rounded-full border-2 border-background-50 ${
                  idx === 0 ? 'bg-primary-500 border-primary-500' : 'bg-accent-500 border-accent-500'
                }`}></div>
                <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-2">
                    <h3 className="font-medium text-foreground-900 text-sm md:text-base">{item.title}</h3>
                    <span className="text-xs text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full whitespace-nowrap w-fit">
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500">{item.date}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}